//查找数组对象
export function myFilter(arr1, arr2) {
  //根据数组id获取另一个数组中匹配id的对象
  return arr1.filter(ele => arr2.filter(x => x == ele.id).length > 0);
}
export const listAssign = (arrA, arrB) =>
  Object.keys(arrA).forEach(key => {
    return (arrA[key] = arrB[key] || arrA[key]);
  });
/**
 * @param {Object} obj
 * @param {Array} key
 * @returns {Object} obj
 */
export function delObj(obj, key) {
  key.map(i => {
    delete obj[i];
  });
  return obj;
}
// 节流throttle代码（定时器）：
export function throttle(func, delay) {
  var timer = null;
  return function() {
    var context = this;
    var args = arguments;
    if (!timer) {
      timer = setTimeout(function() {
        func.apply(context, args);
        timer = null;
      }, delay);
    }
  };
}
/***
 * @param func 输入完成的回调函数
 * @param delay 延迟时间
 */
export const debounce = (func, delay = 200) => {
  let timeout = null;
  return function() {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, arguments);
    }, delay);
  };
};

export function checkMoneyStr(val) {
  const MaxMoney = 999999.99;
  const str = val.toString();
  // 首位只有一个 0
  if (str.substr(0, 2) === "00") return false;
  // 首位禁止小数
  if (str.substring(0, 1) === ".") return false;
  // 小数点
  if (str.indexOf(".") > -1) {
    // 禁止两个小数点输入
    if (str.split(".").length > 2) return false;
    // 小数后最多输入两位
    if (str.split(".")[1].length > 2) return false;
  }
  // 最大限额
  if (Number(str) > MaxMoney) return false;
  return true;
}
export function time(date) {
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var minute = date.getMinutes();
  minute = minute < 10 ? "0" + minute : minute;
  var second = date.getSeconds();
  second = second < 10 ? "0" + second : second;
  return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
}

export function rewirteLog() {
  console.log = (function() {
    return function() {};
  })(console.log);
}
